import { render, staticRenderFns } from "./MaterialForm.vue?vue&type=template&id=2a1be868&"
import script from "./MaterialForm.vue?vue&type=script&lang=js&"
export * from "./MaterialForm.vue?vue&type=script&lang=js&"
import style0 from "./MaterialForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports